import React from 'react';
import styles from './PlaceReview.module.scss';
import {MDBCol, MDBRow} from 'mdbreact';
import LinkBlockContainer from 'data/redux/containers/linkBlockContainer';
import moment from 'moment';
import PlaceReviewText from './components/placeReviewText';
import FavoriteIcon from '@material-ui/icons/Favorite';
import {Rating} from '@material-ui/lab';
import {withStyles} from '@material-ui/core/styles';
import {IPlaceDetailsReview} from 'data/interfaces/products';


interface IPlaceReviewProps {
  review: Partial<IPlaceDetailsReview>;
}

const StyledRating = withStyles({
  iconFilled: {
    color: '#ff6d75',
  },
  iconHover: {
    color: '#ff3d47',
  },
})(Rating);


const PlaceReview = (props: IPlaceReviewProps) => (
  <article className={styles.PlaceReview}>
    <MDBRow>
      <MDBCol sm="7">
        <LinkBlockContainer title={props.review.author_name} className={styles.name} href={props.review.author_url}>
          <img referrerPolicy="no-referrer"
               alt={props.review.author_name}
               className={styles.profilePhoto}
               src={props.review.profile_photo_url}
               loading="lazy"
          />
          {props.review.author_name}
        </LinkBlockContainer>
      </MDBCol>
      <MDBCol sm="5">
        <div className={styles.time} title={moment.unix(props.review.time).format('DD.MM.YYYY HH:mm')}>
          {moment.unix(props.review.time).format('DD.MM.YYYY')}
        </div>
        <StyledRating
          className={styles.rating}
          name="customized-color"
          value={props.review.rating}
          getLabelText={(value: number) => `${value} Heart${value !== 1 ? 's' : ''}`}
          precision={0.5}
          readOnly
          icon={<FavoriteIcon fontSize="inherit"/>}
        />
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol sm='12'>
        <PlaceReviewText review={props.review}/>
      </MDBCol>
    </MDBRow>
  </article>
);
PlaceReview.defaultProps = {};

export default React.memo(PlaceReview);
